import { useState, useEffect } from 'react';

const PLACEHOLDER_TEXTS = [
  "Crie qualquer documento jurídico...",
  "Escreva uma petição inicial de cobrança...",
  "Faça um contrato de locação...",
  "Crie uma contestação...",
  "Elabore um memorial descritivo..."
];

export const useAnimatedPlaceholder = () => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const targetText = PLACEHOLDER_TEXTS[currentIndex];
    
    if (isTyping) {
      // Typing effect
      if (currentText.length < targetText.length) {
        const timeout = setTimeout(() => {
          setCurrentText(targetText.slice(0, currentText.length + 1));
        }, 100);
        return () => clearTimeout(timeout);
      } else {
        // Pause before deleting
        const timeout = setTimeout(() => {
          setIsTyping(false);
        }, 2000);
        return () => clearTimeout(timeout);
      }
    } else {
      // Deleting effect
      if (currentText.length > 0) {
        const timeout = setTimeout(() => {
          setCurrentText(currentText.slice(0, -1));
        }, 50);
        return () => clearTimeout(timeout);
      } else {
        // Move to next text
        setCurrentIndex((prev) => (prev + 1) % PLACEHOLDER_TEXTS.length);
        setIsTyping(true);
      }
    }
  }, [currentText, currentIndex, isTyping]);

  return currentText;
};